module.exports = "https://99designs-start-assets.imgix.net/js/57480b016a1cab3626e11af2c803c27f.png";